import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { ActionSource } from 'owa-mail-store';

export default action(
    'toggleIgnoreConversations',
    (
        rowKeysToIgnore: string[],
        tableViewId: string,
        shouldIgnore: boolean,
        actionSource: ActionSource
    ) => ({
        rowKeysToIgnore: rowKeysToIgnore,
        tableViewId: tableViewId,
        shouldIgnore: shouldIgnore,
        actionSource: actionSource,
    })
);

export const internalToggleIgnoreConversations = action(
    'INTERNAL_TOGGLE_IGNORE_CONVERSATION',
    (
        rowKeysToIgnore: string[],
        tableViewId: string,
        shouldIgnore: boolean,
        actionSource: ActionSource
    ) =>
        addDatapointConfig(
            {
                name: 'TnS_Ignore',
                customData: [actionSource, shouldIgnore],
                options: { isCore: true },
            },
            {
                rowKeysToIgnore,
                tableViewId,
                shouldIgnore,
                actionSource,
            }
        )
);
